module.exports = __webpack_public_path__ + "img/GAME_COLORLOTUS2.e0e8584c.jpg";